export const colors = {
  background: '#F5F5F5',
  ocean: {
    100: '#0E3850',
    200: '#184E6D',
    300: '#062537',
    400: '#3C6278',
    500: '#234F6A',
  },
  linkBlue: '#00A3FF',
  button: '#0A3E5C',
  button2: '#849FAD',
  miniCard: 'rgba(224, 224, 224, 1)',
  black: '#000000',
  gray: {
    100: '#A3A2A8',
    200: '#ECECEC',
    300: '#AAAAAA',
    400: '#ACACAC',
    500: '#747474',
    600: '#E2E8F0',
    700: '#E8E8E8',
    800: '#F7F9FB',
    900: '#B8CAD5',
    1000: '#EDEFF2',
  },
  text: {
    100: '#303030',
    200: '#828282',
    300: '#707070',
  },
  white: '#FFFFFF',
  negative: '#FF0000',
  positive: '#7A9E86',

  yellow: {
    100: '#F2C94C',
    200: '#FBF7EA',
    300: '#CCB05F',
  },
  orange: {
    100: '#F38B00',
  },
  blue: {
    100: '#56B9F2',
    200: '#2686BE',
    300: '#0b3f5d',
    400: '#E0E0F3',
  },
  green: {
    100: '#22C38E',
    200: '#BBF7D0',
    300: '#166534',
  },
  mapDisabled: '#ACACAC',
  map1Color: {
    default: 'rgba(144, 145, 201, 0.2)',
    active: 'rgba(144, 145, 201, 1)',
  },
  map2Color: {
    default: 'rgba(234, 245, 135, 0.2)',
    active: 'rgba(234, 245, 135, 1)',
  },
  map3Color: {
    default: 'rgba(180, 216, 96, 0.2)',
    active: 'rgba(180, 216, 96, 1)',
  },
  map4Color: {
    default: 'rgba(150, 167, 0, 0.2)',
    active: 'rgba(150, 167, 0, 1)',
  },
  map5Color: {
    default: 'rgba(186, 153, 122, 0.2)',
    active: 'rgba(186, 153, 122, 1)',
  },
  map6Color: {
    default: 'rgba(255, 176, 101, 0.2)',
    active: 'rgba(255, 176, 101, 1)',
  },
  map7Color: {
    default: 'rgba(191, 205, 64, 0.2)',
    active: 'rgba(191, 205, 64, 1)',
  },
  map8Color: {
    default: 'rgba(93, 93, 121, 0.2)',
    active: 'rgba(93, 93, 121, 1)',
  },
  map9Color: {
    default: 'rgba(214, 233, 169, 0.2)',
    active: 'rgba(214, 233, 169, 1)',
  },
  map10Color: {
    default: 'rgba(242, 204, 255, 0.2)',
    active: 'rgba(242, 204, 255, 1)',
  },
  services: {
    total: 'rgba(10, 62, 92, 1)',
    preventive: 'rgba(247, 217, 0, 1)',
    corrective: 'rgba(162, 217, 229, 1)',
    sinister: 'rgba(0, 179, 197, 1)',
    others: 'rgba(248, 234, 153, 1)',
  },
  brazil: {
    age: '#56B9F2',
    km: '#00A3FF',
  },
  se_region: {
    age: '#F0C5FF',
    km: '#DD9AF4',
  },
  so_region: {
    age: '#8889BE',
    km: '#797AA9',
  },
  ne_region: {
    age: '#D6E07C',
    km: '#BCC56C',
  },
  no_region: {
    age: '#E49D5A',
    km: '#BE834B',
  },
  cw_region: {
    age: '#BECE96',
    km: '#A1B080',
  },
};
